// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3YRIk","col":"Table_col__1nqrR","fulfillmentStatus":"Table_fulfillmentStatus__1yFox","emailCol":"Table_emailCol__2GrBg"};